import React from 'react'
import './WeDefeated.scss';
import WithoutImage from '../../../Assets/Images/without.png';
import MoneyIcon from '../../../Assets/Images/money.png';
import DolorIcon from '../../../Assets/Images/dolor.png';
import Unfeat1Icon from '../../../Assets/Images/unfeat1.png';
import SettingIcon from '../../../Assets/Images/setting.png';
import PlatformImage from '../../../Assets/Images/platform.png';
import JourneyImage from '../../../Assets/Images/team.png';
export default function WeDefeated() {
    return (
        <>
           <section className="ai-journey" id="AboutUs">
                <div className="journey-container">
                    <div className="grid">
                        <div className="grid-items">
                            <div className="sub-grid">
                                <div className="sub-grid-tems">
                                    <h2>Starting your AI journey?</h2>
                                    <p>
                                        Leverage our team experience in deep learning and autonomous systems in financial services to productionize 
                                        complex AI system in production through our off the shelves products or platforms.
                                    </p>
                                    <h3>Ideate, Innovate & Stay ahead!</h3>
                                    <button>Connect with Core.ai</button>
                                </div>
                            </div>
                        </div>
                        <div className="grid-items">
                            <img src={JourneyImage} alt="JourneyImage"/>
                        </div>
                    </div>
                </div>
           </section>
        </>
    )
}
